import { replaceAll } from 'helpers/replaceAll';

function truncateAtWordBoundary(text: string, maxLength: number, isEllipsisRequired: boolean): string {
    if (text.length <= maxLength) {
        return text;
    }

    let end = maxLength;

    if (text.charAt(maxLength) !== ' ') {
        const nextSpace = text.indexOf(' ', maxLength);
        end = nextSpace === -1 ? text.length : nextSpace;
    }

    return text.substring(0, end) + (isEllipsisRequired && end < text.length ? '...' : '');
}

export function substringStripHtml(
    text: string | null,
    maxLength: number | null,
    addEllipsisOnTextOverflow = true,
): string | undefined {
    if (!text) {
        return undefined;
    }

    let newString = text;

    newString = replaceAll(newString, '<li>', ' -'); // change
    newString = replaceAll(newString, '</li>', '');
    newString = replaceAll(newString, '</ul>', ' '); // space after ul
    newString = newString.replace(/(<([^>]+)>)/gi, ''); // remove html
    newString = replaceAll(newString, '\t', ' '); // remove tabs
    newString = replaceAll(newString, '&amp;nbsp;', '&');
    newString = replaceAll(newString, '&amp;quot', '"');
    newString = replaceAll(newString, '&amp;', '&');
    newString = replaceAll(newString, '&nbsp;', ' ');
    newString = newString.replace(/(r\n|\n|\r)/gm, ''); // remove nextlines

    const isEllipsisRequired = maxLength !== null && newString.length > maxLength && addEllipsisOnTextOverflow;

    if (maxLength !== null) {
        return truncateAtWordBoundary(newString, maxLength, isEllipsisRequired);
    }

    return newString;
}
